<template>
  <a-modal
    :visible="detailVisible"
    :footer="false"
    @cancel="$emit('update:detailVisible', false)"
    :bodyStyle="{
      padding: '0 16px 8px',
      maxHeight: '600px',
      overflowY: 'auto'
    }"
  >
    <template slot="title">
      <div style="text-align: center;">任务详情</div>
    </template>
    <a-row :gutter="[8, 8]">
      <a-col :span="12">
        <span class="content-title">站点名称：</span>
        {{ details.station_name }}</a-col
      >
      <a-col :span="12"
        ><span class="content-title">设备号：</span>{{ details.sn }}</a-col
      >
      <a-col :span="12"
        ><span class="content-title">区县：</span>{{ details.quxian }}</a-col
      >
      <a-col :span="12"
        ><span class="content-title">任务类型：</span
        >{{ details.task_type_name }}</a-col
      >
      <a-col :span="24"
        ><span class="content-title">指派人：</span
        >{{ record.ops_user | opsUsersFormat }}</a-col
      >
      <a-col :span="24"
        ><span class="content-title">内容：</span>{{ details.comment }}</a-col
      >
    </a-row>
    <div class="task-info__title">
      任务信息
    </div>
    <div v-for="(item, index) in details.ops_log" :key="index">
      <div>
        <span class="content-title" style="margin: 10px 0;">运维人员：</span
        >{{ item.ops_log_user_name }}
      </div>
      <div>
        <span class="content-title" style="margin: 10px 0;">运维记录：</span
        >{{ item.ops_comment }}
      </div>
      <div>
        <img
          v-if="item.pic_url"
          :src="ossBaseUrl + item.pic_url"
          style="width: 100px;height: 100px;"
        />
      </div>
      <div>
        <span class="content-title" style="margin: 10px 0;">时间：</span
        >{{ item.ops_log_created_at }}
      </div>
      <a-divider v-show="details.ops_log.length - 1 != index" />
    </div>
  </a-modal>
</template>

<script>
import { getTaskDetails } from "@/api/api";
import { OSS_PIC_BASE_URL } from "@/config/config";
export default {
  data() {
    return {
      details: {},
      ossBaseUrl: OSS_PIC_BASE_URL
    };
  },
  props: {
    detailVisible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    opsUsersFormat(v) {
      if (v && v.length) {
        return v.map(item => item.name).join(", ");
      }
      return "";
    }
  },
  watch: {
    record(v) {
      if (v) {
        this.getTaskDetails();
      }
    }
  },
  methods: {
    async getTaskDetails() {
      try {
        let res = await getTaskDetails(this.record.id);
        this.details = res.data.data;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.content-title {
  font-weight: 550;
}
.task-info__title {
  font-weight: 600;
  color: #000;
  font-size: 20px;
}
</style>
